import {useI18n} from '@yandex-delivery/core/i18n'
import type {ServerError} from '@yandex-delivery/core/utils/network'
import {Suspense, useMemo} from 'react'
import {useHistory} from 'react-router-dom'

import type {ErrorScreenProps} from '../../../components/ErrorBoundary'
import {ErrorBoundary} from '../../../components/ErrorBoundary'
import {Loader} from '../../../components/ui'
import {useConfig} from '../../../config'
import {Resource} from '../../../utils'
import type {TariffsPageProps} from './TariffsPage'
import {TariffsPage} from './TariffsPage'

type Props = Omit<TariffsPageProps, 'resource'>

export function TariffsPageContainer(props: Props) {
  const {path} = props
  const {city} = path
  const {tariffsService, getPath} = useConfig()

  const tariffsResource = useMemo(
    () => new Resource(() => tariffsService.fetchTariffsList(path.country, city!)),
    [city, path.country, tariffsService],
  )

  const {push} = useHistory()
  const i18n = useI18n()

  const getScreenProps = ({body}: ServerError): ErrorScreenProps => {
    if (body?.code !== 'unknown_zone') {
      return {
        buttonProps: {
          view: 'action',
        },
      }
    }

    return {
      buttonProps: {
        action: () => {
          push(getPath({country: path.country}))
        },
        text: i18n('tariffs-v3.error.button.unknown-zone', 'Выбрать другой'),
        view: 'action',
      },
      text: i18n('tariffs-v3.error.unknown-zone', 'Не нашли ваш город'),
    }
  }

  return (
    <ErrorBoundary getScreenProps={getScreenProps}>
      <Suspense fallback={<Loader />}>
        <TariffsPage resource={tariffsResource} {...props} />
      </Suspense>
    </ErrorBoundary>
  )
}
